import { createElement } from "react";
import toast from "react-hot-toast";

import { UndoToast } from "./components/UndoToast";

/** Six seconds: long enough to notice and react, short enough not to linger. */
const UNDO_TOAST_MS = 6000;

/**
 * Fire the undo affordance for a destructive layout edit.
 *
 * Separate module from the component it renders, and built with `createElement`
 * rather than JSX, so neither file mixes a component export with a plain
 * function export — `react-refresh/only-export-components` is an error here, and
 * a file that trips it silently loses hot reload for everything importing it.
 */
export const showUndoToast = (message: string, onUndo: () => void) =>
  toast.custom(
    (item) =>
      createElement(UndoToast, {
        message,
        onUndo,
        onDismiss: () => toast.dismiss(item.id),
      }),
    { duration: UNDO_TOAST_MS },
  );
